import React, {useContext, useState} from 'react';
import Grid from "@mui/material/Grid";
import {SintomiGrid} from "../../gestione/interviste/intervista/content/SintomiGrid";
import {sintomi, tipiDocumento, tipiDocumentoCodf} from "../../../utils/arrays/Generics";
import {
	emailRegister,
	phoneRegister,
	valueRegister
} from "../../../utils/RegisterUtils";
import { Alert, AlertTitle } from '@mui/material';
import {MonitorStyle} from "../../../styles/pages/monitor/MonitorStyle";
import {useFormContext} from "react-hook-form";
import {RischioGrid} from "../../gestione/interviste/intervista/content/RischioGrid";
import {Button, Divider, MenuItem, Typography} from "@mui/material";
import CustomSelect from "../../widgets/inputs/CustomSelect";
import CustomText from "../../widgets/inputs/CustomText";
import {languages} from "../../../strings/LanguageDictionary";
import {AppContext} from "../../../App";
import {RadioGroupQuestion} from "../../widgets/inputs/RadioGroupQuestion";
import {COMPARSA_SINTOMI, PRESENTA_SINTOMI_3a} from "../../../strings/IT";
import CustomDateInput from "../../widgets/inputs/CustomDateInput";
import {CustomAutoComplete} from "../../widgets/inputs/CustomAutoComplete";

export const SegnalazionePositivoGrid = ({
	                                         initialStateCompagni = [],
	                                         disabledButton = false,
	                                         showAlert = true,
	                                         isCompagni = true,
	                                         isCasoIndice = true,
	                                         dataEsito = new Date(),
                                         }) => {
	const monitorClasses = MonitorStyle();
	const appContext = useContext(AppContext);
	const {errors, control, watch} = useFormContext();
	const [compagni, setCompagni] = useState(initialStateCompagni);
	
	return (
		<React.Fragment>
			
			{showAlert && <Grid item xs={12}>
				<Alert severity={"info"} style={{borderRadius: 24}}>
					<AlertTitle><b>{languages[appContext.state.lang].SEGNALAZIONE_POSITIVO_ALERT_TITLE}</b></AlertTitle>
					{languages[appContext.state.lang].SEGNALAZIONE_POSITIVO_ALERT_INFO_}
				</Alert>
			</Grid>}
			
			<SintomiGrid isRientri={true} dataEsito={dataEsito}/>
			
			<RischioGrid isCit={true} isCasoIndice={isCasoIndice}/>
			
			{
				isCompagni && (watch("conviventiSintomi") === "true") &&
				<React.Fragment>
					<Grid item xs={12}>
						<Typography variant={"subtitle1"} color={"textSecondary"}>
							Il convivente sintomatico deve contattare il proprio medico di medicina generale; per l'effettuazione del
							tampone può comunicare i suoi dati all'ASL Città di Torino attraverso l'apertura di un ticket al seguente
							link <a href="https://ocean.aslcittaditorino.it/contattaci/covid_19/ticket" target={"_blank"}
							        rel={"noreferrer"}>Ticket segnalazione contatto di positivo</a>, indicando come categoria "Covid
							19" e sottocategoria "Segnalazione contatto positivo".
						</Typography>
					</Grid>
					{/*<Grid item xs={12} className={monitorClasses.subQuestion} style={{marginTop: 8}}>
						<Grid container spacing={3}>
							<Grid item xs={12}>
								<Typography variant={"subtitle1"} color={"primary"}>
									<b>Contatto convivente n°1</b>
								</Typography>
								<Typography variant={"subtitle2"} color={"textSecondary"}>
									É obbligatorio indicare un documento d'identificazione
								</Typography>
							</Grid>
							<Grid item xs={12} sm={6}>
								<CustomSelect
									name={"contatti.0.tipoDocumento"}
									label={"Metodo identificazione"}
									control={control}
									defaultValue={tipiDocumento[0].val}
									autoFocus={false}
									rules={{
										required: true,
									}}
									error={errors["contatti"]?.[0]?.["tipoDocumento"]}
								>
									{
										tipiDocumentoCodf.map(value => {
											return (<MenuItem key={value.val} value={value.val}>{value.label}</MenuItem>)
										})
									}
								</CustomSelect>
							</Grid>
							<Grid item xs={12} sm={6}>
								<CustomText
									control={control}
									rules={valueRegister}
									name={"contatti.0." + watch("contatti")?.[0]?.["tipoDocumento"]}
									label={"Valore documento"}
									autoFocus={false}
									error={errors["contatti"]?.[0]?.[watch("contatti")?.[0]?.["tipoDocumento"]]}
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								<CustomText
									control={control}
									rules={valueRegister}
									name={"contatti.0.nome"}
									label={"Nome"}
									autoFocus={false}
									error={errors["contatti"]?.[0]?.["nome"]}
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								<CustomText
									control={control}
									rules={valueRegister}
									name={"contatti.0.cognome"}
									label={"Cognome"}
									autoFocus={false}
									error={errors["contatti"]?.[0]?.["cognome"]}
								/>
							</Grid>
							<Grid item xs={12} sm={8}>
								<CustomText
									control={control}
									rules={emailRegister}
									name={"contatti.0.email"}
									label={"Email"}
									autoFocus={false}
									error={errors["contatti"]?.[0]?.["email"]}
								/>
							</Grid>
							<Grid item xs={12} sm={4}>
								<CustomText
									control={control}
									rules={phoneRegister}
									name={"contatti.0.cell"}
									label={"Cellulare"}
									autoFocus={false}
									error={errors["contatti"]?.[0]?.["cell"]}
								/>
							</Grid>
							<Grid item xs={12}>
								<CustomAutoComplete
									control={control}
									name={"contatti.0.sintomi"}
									options={sintomi}
									multiple={true}
									placeholder={"Elenca i sintomi selezionandoli dal menù"}
									rules={{required: true}}
									error={errors["contatti"]?.[0]?.["sintomi"]}
								/>
							</Grid>
							<Grid item xs={12}>
								<CustomDateInput
									label={COMPARSA_SINTOMI}
									control={control}
									defaultValue={null}
									maxDate={new Date()}
									rules={{required: true}}
									name={"contatti.0.dataComparsaSintomi"}
									error={errors["contatti"]?.[0]?.["dataComparsaSintomi"]}
								/>
							</Grid>
							<Grid item xs={3} sm={9} style={{display: "flex", alignItems: "center"}}>
								<Divider style={{width: "100%"}}/>
							</Grid>
							<Grid item xs={9} sm={3} style={{display: "flex", alignItems: "center"}}>
								<Button style={{borderRadius: 24, textAlign: "center"}} fullWidth disabled={disabledButton}
								        onClick={() => setCompagni(prevState => [...prevState, "."])}>
									Aggiungi contatto
								</Button>
							</Grid>
						
						</Grid>
					</Grid>*/}
					{
						compagni.map((contatto, index) => {
							return (
								<Grid item xs={12} key={index + contatto} className={monitorClasses.subQuestion} style={{marginTop: 8}}>
									<Grid container spacing={3}>
										<Grid item xs={12}>
											<Typography variant={"subtitle1"} color={"primary"}>
												<b>Contatto convivente n°{index + 2}</b>
											</Typography>
											<Typography variant={"subtitle2"} color={"textSecondary"}>
												É obbligatorio indicare un documento d'identificazione del contatto
											</Typography>
										</Grid>
										<Grid item xs={12} sm={6}>
											<CustomSelect
												name={"contatti." + (index + 1) + ".tipoDocumento"}
												label={"Metodo identificazione"}
												control={control}
												defaultValue={tipiDocumento[0].val}
												autoFocus={false}
												rules={{
													required: true,
												}}
												error={errors["contatti"]?.[index + 1]?.["tipoDocumento"]}
											>
												{
													tipiDocumentoCodf.map(value => {
														return (<MenuItem key={value.val} value={value.val}>{value.label}</MenuItem>)
													})
												}
											</CustomSelect>
										</Grid>
										<Grid item xs={12} sm={6}>
											<CustomText
												control={control}
												rules={valueRegister}
												name={"contatti." + (index + 1) + "." + watch("contatti")?.[(index + 1)]?.["tipoDocumento"]}
												label={"Valore documento"}
												autoFocus={false}
												error={errors["contatti"]?.[index + 1]?.[watch("contatti")?.[(index + 1)]?.["tipoDocumento"]]}
											/>
										</Grid>
										<Grid item xs={12} sm={6}>
											<CustomText
												control={control}
												rules={valueRegister}
												name={"contatti." + (index + 1) + ".nome"}
												label={"Nome"}
												autoFocus={false}
												error={errors["contatti"]?.[index + 1]?.["nome"]}
											/>
										</Grid>
										<Grid item xs={12} sm={6}>
											<CustomText
												control={control}
												rules={valueRegister}
												name={"contatti." + (index + 1) + ".cognome"}
												label={"Cognome"}
												autoFocus={false}
												error={errors["contatti"]?.[index + 1]?.["cognome"]}
											/>
										</Grid>
										<Grid item xs={12} sm={8}>
											<CustomText
												control={control}
												rules={emailRegister}
												name={"contatti." + (index + 1) + ".email"}
												label={"Email"}
												autoFocus={false}
												error={errors["contatti"]?.[index + 1]?.["email"]}
											/>
										</Grid>
										<Grid item xs={12} sm={4}>
											<CustomText
												control={control}
												rules={phoneRegister}
												name={"contatti." + (index + 1) + ".cell"}
												label={"Cellulare"}
												autoFocus={false}
												error={errors["contatti"]?.[index + 1]?.["cell"]}
											/>
										</Grid>
										<Grid item xs={12}>
											<RadioGroupQuestion
												question={PRESENTA_SINTOMI_3a}
												control={control}
												autoFocus={true}
												defaultValue={""}
												rules={{required: true}}
												name={"contatti." + (index + 1) + ".presentaSintomi"}
												error={errors["contatti"]?.[index + 1]?.["presentaSintomi"]}
											/>
										</Grid>
										{
											watch("contatti")?.[index + 1]?.presentaSintomi === "true" &&
											<React.Fragment>
												<Grid item xs={12} className={monitorClasses.subQuestionStart}>
													<CustomAutoComplete
														control={control}
														name={"contatti." + (index + 1) + ".sintomi"}
														options={sintomi}
														multiple={true}
														rules={{required: true}}
														error={errors["contatti"]?.[index + 1]?.["sintomi"]}
													/>
												</Grid>
												<Grid item xs={12} className={monitorClasses.subQuestionEnd}>
													<CustomDateInput
														label={COMPARSA_SINTOMI}
														control={control}
														defaultValue={null}
														maxDate={new Date()}
														rules={{required: true}}
														name={"contatti." + (index + 1) + ".dataComparsaSintomi"}
														error={errors["contatti"]?.[(index + 1)]?.["dataComparsaSintomi"]}
													/>
												</Grid>
											</React.Fragment>
										}
										<Grid item xs={1} sm={5} style={{display: "flex", alignItems: "center"}}>
											<Divider style={{width: "100%"}}/>
										</Grid>
										<Grid item xs={5} sm={3} style={{display: "flex", alignItems: "center"}}>
											<Button style={{borderRadius: 24, textAlign: "center"}} fullWidth disabled={disabledButton}
											        onClick={() => setCompagni(prevState => [...prevState, "."])}>
												Aggiungi contatto
											</Button>
										</Grid>
										<Grid item xs={1} sm={1} style={{display: "flex", alignItems: "center"}}>
											<Divider style={{width: "100%"}}/>
										</Grid>
										<Grid item xs={5} sm={3} style={{display: "flex", alignItems: "center"}}>
											<Button style={{borderRadius: 24, textAlign: "center"}} fullWidth disabled={disabledButton}
											        onClick={() => setCompagni(prevState => prevState.splice(1))}>
												Rimuovi contatto
											</Button>
										</Grid>
									
									</Grid>
								</Grid>
							)
						})
					}
				</React.Fragment>
			}
		
		
		</React.Fragment>
	);
}
